/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const UpdateWarehousePackageStatusRequestTargetStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * Check if a given object implements the UpdateWarehousePackageStatusRequest interface.
 */
export function instanceOfUpdateWarehousePackageStatusRequest(value) {
    if (!('targetStatus' in value) || value['targetStatus'] === undefined)
        return false;
    return true;
}
export function UpdateWarehousePackageStatusRequestFromJSON(json) {
    return UpdateWarehousePackageStatusRequestFromJSONTyped(json, false);
}
export function UpdateWarehousePackageStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'targetStatus': json['targetStatus'],
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingUrl': json['trackingUrl'] == null ? undefined : json['trackingUrl'],
        'productCostUsd': json['productCostUsd'] == null ? undefined : json['productCostUsd'],
        'skipWarehouse': json['skipWarehouse'] == null ? undefined : json['skipWarehouse'],
        'giftCardUsd': json['giftCardUsd'] == null ? undefined : json['giftCardUsd'],
        'promisedDeliveryDate': json['promisedDeliveryDate'] == null ? undefined : (new Date(json['promisedDeliveryDate'])),
    };
}
export function UpdateWarehousePackageStatusRequestToJSON(json) {
    return UpdateWarehousePackageStatusRequestToJSONTyped(json, false);
}
export function UpdateWarehousePackageStatusRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'targetStatus': value['targetStatus'],
        'buyerOrderId': value['buyerOrderId'],
        'trackingNumber': value['trackingNumber'],
        'trackingUrl': value['trackingUrl'],
        'productCostUsd': value['productCostUsd'],
        'skipWarehouse': value['skipWarehouse'],
        'giftCardUsd': value['giftCardUsd'],
        'promisedDeliveryDate': value['promisedDeliveryDate'] == null ? undefined : ((value['promisedDeliveryDate']).toISOString().substring(0, 10)),
    };
}
